import { motion } from "framer-motion";

import { PlatformLogo } from "@/components/PlatformLogo";
import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingHeader } from "@/modules/onboarding/components/OnboardingScreenHeader/OnboardingHeader";
import { Button } from "atoms/button/Button";

import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface PersonalisationWelcomeScreenProps {
  platformName: string;
  platformLogoUrl?: string;
  userFirstName: string;
  onGetStarted: () => void;
}

export function PersonalisationWelcomeScreen({
  platformName,
  platformLogoUrl,
  userFirstName,
  onGetStarted,
}: PersonalisationWelcomeScreenProps) {
  return (
    <PersonalisationScreenLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="mx-auto flex w-[322px] flex-1 flex-col items-center pt-[50%]"
      >
        <PlatformLogo
          platformName={platformName}
          logoUrl={platformLogoUrl}
          className="mb-16"
        />

        <OnboardingHeader
          title={
            <>
              Welcome to
              <br />
              {platformName},
              <br /> {userFirstName}.
            </>
          }
          subtitle="We're so glad you're here."
          className="mb-8"
          titleClassName="!text-[30px] !leading-8 text-center"
          subtitleClassName="mt-4"
        />
        <Button fullWidth onClick={onGetStarted}>
          Get started
        </Button>
      </motion.div>
    </PersonalisationScreenLayout>
  );
}
